import { productCategory } from './product_category'
import * as productItems from './product_items'
import { adapter } from './product_adapter'

/** Process Image Path */
for (let key in productItems) {
    let imgL = (productItems[key].imgL ?? 5) + 1;
    //Product Banner
    productItems[key].banner = require(`@/assets/images/products/${key}/${key}_banner.jpg`)
    //Product Main Images
    for (let i = 1; i < imgL; i++) {
        try {
            adapter[key].src = require(`@/assets/images/adapters/${key}.jpg`)
        } catch (e) {
            productItems[key].images.push(require(`@/assets/images/products/${key}/${key}_0${i}.jpg`))
        }
    }
    //Feature Icons
    productItems[key].featureIcons = productItems[key].featureIcons.map(v => require(`@/assets/images/feature_icons/${v}.png`))
    //Other Features
    if (productItems[key].otherFeatures.lenght !== 0) {
        productItems[key].otherFeatures = productItems[key].otherFeatures.map(v => require(`@/assets/images/products/${key}/${key}_feature_${v}.jpg`))
    }
}
/** Adapter Image Path */
for (let key in adapter) {
    // console.log(require(`@/assets/images/adapters/${key}.jpg`));
    // adapter[key].src = require(`@/assets/images/adapters/${key}.jpg`)
    try {
        adapter[key].src = require(`@/assets/images/adapters/${key}.jpg`)
    } catch (e) {
        console.error(`Adapter image for ${key} not found`)
    }
}

export {
    productCategory,
    productItems,
    adapter
}